// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"800b050c","795":"5212d270"}[chunkId] + ".chunk.css";
};